var _path, _path2, _path3, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLowerTaxPrice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42.52 42.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M38.71 32.3l-5.48 5.48-5.48-5.48M33.23 36.27l-.03-12.51"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_sub",
    d: "M22.28 13.4c-7.61-2.21-7.61 5.77-2.81 5.66 4.7-.1 5.29 7.51-3.07 5.19M19.29 11.71v.69M19.29 25.3v.7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M22.9 32.52c-1.22.34-2.51.53-3.83.53-7.82 0-14.16-6.34-14.16-14.16S11.25 4.73 19.07 4.73c6.18 0 11.43 3.96 13.36 9.47"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_dot",
    cx: 33.2,
    cy: 18.92,
    r: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLowerTaxPrice);
export default __webpack_public_path__ + "static/media/lowerTaxPrice.7175d2ad0dd96e1a6d9df5086d0712b1.svg";
export { ForwardRef as ReactComponent };